/**
 *
 *  ? url pada submenu menggunakana naming routes,
 *  ? jadi tidak perlu dibuat format url lengkap
 */
export default [
  {
    icon: "ListIcon",
    menu: "Kuisioner Institusi",
    url: "lp3m-kuisioner-institusi",
  },
  {
    icon: "ListIcon",
    menu: "Kuisioner Mata Kuliah",
    url: "lp3m-kuisioner-matkul",
  },
  {
    icon: "BookIcon",
    menu: "Report Kuisioner",
    url: "lp3m-report-kuisioner",
  },
];
